import React from "react";
import OfficeChatSpeedDialBtn from "./officeChatSpeedDialBtn";

const Footer = ({is_current_job_page}) => {
    return (
        <footer className="footer py-4 fixed-bottom">
            <div className="container-fluid">
                <div className="row align-items-center justify-content-lg-between">
                    {!is_current_job_page && <OfficeChatSpeedDialBtn />}
                </div>
            </div>
        </footer>
    );
}

export default Footer;